import style from "./index.css";
import webcss from "../../pages/web.css";
import { useEffect, useState } from "react";
import { apifetch } from "../../utils";
import { INTEGRATION_URL } from "../../utils/constants";
import Table from "./Table";
import { toLower } from "ramda";
import Link from "next/link";
import Loader from "../Loader";
import Faq from "../Faq";
import { BlueButton, OutlineButton } from "../Button";
import MobilePricingView from "./MobilePricingView";

const PricingSection = ({ 
  productShort, 
  featuresLink, 
  specificFaqs,
  bottomHeroText='Grow your business with 1GOV Merchant'
 }) => {
  const [productOffers, setProductOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [defaultOffer, setDefaultOffer] = useState(null);

  const getOffers = async () => {
    const url = `${INTEGRATION_URL}/fetchProductOffers?name=${productShort}`;
    try {
      setLoading(true);
      const result = await apifetch(url);
      setLoading(false);
      if (result) {
        let productOffers = result.offerList ? result.offerList : [];
        setProductOffers(productOffers);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getOffers();
  }, []);

  useEffect(() => {
    const defaultOffer =
      productOffers.length > 0
        ? productOffers.find((offer) => toLower(offer.name) == "premium")
        : productOffers[0];
    setDefaultOffer(defaultOffer);
  }, [productOffers]);

  return (
    <>
      <div className={`container ${productShort} single-product`}>
        <div className="top-intro">
          <p className="main-title">Pricing Plan</p>
          <p>
            Try now and scale the team with ease.
            <br />
            <strong>Try it free for 30 days.</strong>
          </p>
          <div className="cta-cont">
            {defaultOffer && (
              <Link
                href={{
                  pathname: "/subscribe",
                  query: {
                    offer: defaultOffer.token,
                    trial: defaultOffer.hasTrial,
                    isBundle: defaultOffer.groupId ? true : false,
                  },
                }}
                passHref
              >
                <BlueButton
                  size="large"
                  label={defaultOffer.hasTrial ? "Start Free Trial" : "Sign up now"}
                />
              </Link>
            )}
            {featuresLink && (
              <Link href={featuresLink}>
                <OutlineButton className="cicod-btn-lg" color="blue">
                  Features
                </OutlineButton>
              </Link>
            )}
          </div>
          {loading && <Loader />}
        </div>
        {!loading && productOffers.length > 0 && (
          <MobilePricingView offers={productOffers} />
        )}
        {!loading && productOffers.length > 0 && (
          <Table offers={productOffers} product={productShort} />
        )}
        {!loading && productOffers.length < 1 && (
          <h3>There are no offers available</h3>
        )}
      </div>

      <div className="faq-section">
        <div className="container">
          <div className="faq-section--container">
            <div className="qestions-section">
              <p>Frequently asked questions</p>
              <Faq
              specificFaqs={specificFaqs}
               />
            </div>
            <div className="img-section">
              <img src="/static/img/iso-image.png" alt="#" />
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-hero">
        <p>{bottomHeroText}</p>
        <p>Start your 30days free trial</p>
        {defaultOffer && (
          <Link
            href={{
              pathname: "/subscribe",
              query: {
                offer: defaultOffer.token,
                trial: defaultOffer.hasTrial,
                isBundle: defaultOffer.groupId ? true : false,
              },
            }}
            passHref
          >
            <a className="cicod-btn cicod-btn-red">
              {defaultOffer.hasTrial ? "Start Free Trial" : "Sign up now"}
            </a>
          </Link>
        )}
      </div>
      <style jsx>{webcss}</style>
      <style jsx>{style}</style>
    </>
  );
};

export default PricingSection;
